export default __webpack_public_path__ + "static/media/intel7400.76c2e0b5.jpg";